import { AnnotationData } from './annotation-data.model';
import { ApiAnnotation } from './api-annotation.model';

export function isValidAnnotation(annotation: AnnotationData | ApiAnnotation): boolean {
  return !!annotation?.highlight || !!annotation?.placemarkText || !!annotation?.note;
}
